import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Redact } from '../class/redact';

@Component({
    selector: 'app-transaction-terminated',
    templateUrl: './transaction-terminated.component.html',
    styleUrls: ['./transaction-terminated.component.scss']
})
export class TransactionTerminatedComponent implements OnInit {

    showLogo: boolean = true;
    isDI: boolean = false;
    isDkUrl: boolean = false;

    companyLogoURL: string = '';

    themeValue: boolean = false;

    loading: boolean = true;
    themeLoaded: boolean = false;

    constructor(
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {

        // Start loader
        this.loading = true;
        this.themeLoaded = false;


        // =========================
        // Theme
        // =========================

        const storedTheme = localStorage.getItem('themeValue');

        if (storedTheme) {

            this.themeValue = JSON.parse(storedTheme);

            this.themeLoaded = true;

        }


        // =========================
        // Language
        // =========================

        const language = localStorage.getItem('Langauge');

        if (language) {

            this.isDkUrl = language === 'da-dk';

            this.translate.use(language);

        }


        // =========================
        // Redact / Branding
        // =========================

        const redact = this.getRedactDetails();

        if (redact != null) {

            if (
                redact.LogoSrc == null ||
                redact.LogoSrc == ''
            ) {

                this.showLogo = false;
                this.companyLogoURL = '';

            }
            else {

                this.showLogo = true;
                this.companyLogoURL = redact.LogoSrc;

            }

        }
        else {

            this.showLogo = false;
            this.companyLogoURL = '';

        }


        // =========================
        // Loader complete
        // =========================

        this.themeLoaded = true;
        setTimeout(() => {
    this.loading = false;
}, 2000);
    }


    getRedactDetails(): any {

        const key = 'redact';

        const redactData = localStorage.getItem(key);

        if (redactData) {
            return JSON.parse(redactData);
        }

        return null;
    }
}